import React, { useEffect, useState } from 'react'
import LabelText from '../../ui/LabelText'
import PrimaryButton from '../../ui/PrimaryButton'
import { useNavigate } from 'react-router-dom'
import MFLoginLogo from '../../assets/images/MF_logo.png';
import { useLoading } from '../../contexts/LoadingContext';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IApiResponse from '../../types/IApiResponse';
import { fetchData, postData } from '../../services/api';
import apiUrls from '../../config/apiUrls';
import handleApiResponse from '../../utils/handleApiResponse';
import { send } from 'node:process';
import LoadingSpinner from '../../ui/LoadingSpinner';
import { AnyARecord } from 'node:dns';

const ForgotPwd = () => {
    const navigate = useNavigate();
    const {startLoading , stopLoading , loading} = useLoading();
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [otp,setOtp] = useState<number>();
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    // const [showFlashScreen, setShowFlashScreen] = useState<boolean>(true);
    const [errorMsg , setErrorMsg] = useState<string>('')
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPasseord, setShowConfirmPassword] = useState<boolean>(false);
    // const [showFadeIn , setShowFadeIn] = useState<boolean>(false);
    const [passwordChnage , setIsPasswordChange] = useState<boolean>(false)
    const [emailError, setEmailError] = useState('');
    const [passwordErrors, setPasswordErrors] = useState<string[]>([]);
    const [sendOtp , setSendOtp] = useState<boolean>(false)
    const [passwordMatch , setIsPassowrdMatch] = useState<string>('')
    const[resendOtp , setIsResendOtp] = useState<boolean>(false)
    const [cooldown, setCooldown] = useState(0);

     const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            setEmail(value);
    
            // Basic email format validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (value && !emailRegex.test(value)) {
                setEmailError('Please enter a valid email address');
            } else {
                setEmailError('');
            }
        };
    const handleClearUsername = () => {
        setEmail('');
    };

    const validatePassword = (value: string) => {
        const errors: string[] = [];
        if(value){
            if (!/[A-Z]/.test(value) || !/[a-z]/.test(value) || !/[0-9]/.test(value) || !/[!@#$%^&*(),.?":{}|<>]/.test(value) || value.length < 8) {
                errors.push("Password must contain 8 characters, include upper & lower case letters, a number, and a special character.");
            }
        }
        return errors;
    };
    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setPassword(value);
        setPasswordErrors(validatePassword(value));
    };
    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const sendOtpFunction = async () => {
        try {
          startLoading();
          const response: IApiResponse<any> = await fetchData(`${apiUrls["SendOtp"]}?UserEmail=${email}`);
          
          handleApiResponse(
            response,
            (data) => {
              setSendOtp(true); 
              stopLoading();
              setErrorMsg('')
            },
            (error) => {
              setErrorMsg(response.error?.message);
              stopLoading();
            }
          );
        } catch (err) {
          console.error("Unhandled error in sendOtp:", err);
          stopLoading();
        }
      };
      
      useEffect(()=>{
        if(resendOtp){
            sendOtpFunction()
            setIsResendOtp(false)
            setCooldown(75);
        }
      },[resendOtp])

      useEffect(() => {
        let timer : any;
        if (cooldown > 0) {
          timer = setInterval(() => {
            setCooldown(prev => prev - 1);
          }, 1000);
        }
        return () => clearInterval(timer);
      }, [cooldown]);


        const formatTime = (seconds :any) => {
            const mins = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
        };



    const handleSubmit = async () =>{
        
        if (password !== confirmPassword) {
            setIsPassowrdMatch('Password and Confirm Password do not match. Please try again.');
        }
        else{
            setIsPassowrdMatch('')
        }
        try {
            startLoading();
          
            const requestParameters = {
              userEmail: email,
              newPassword: confirmPassword,
              otp: otp
            };
            const response: IApiResponse<any> = await postData(apiUrls["ResetPassword"], requestParameters);
            stopLoading(); 
            if (response?.isSuccess) {
                setIsPasswordChange(true)
                setErrorMsg('');
             return true
            } else {
            //   setErrorMsg(response.error.message)
                setErrorMsg('Your OTP is invalid or expired. Request a new one to reset your password.')
              return false;
            }
          
          } catch (error) {
            console.error('Password reset failed:', error);
            stopLoading();
            return false;
          }
          
    }

    const handleConfirmPassowrd = (e:any) =>{
        setConfirmPassword(e.target.value)
    }


  return (
        <div className="login-wrapper">
            <div className="login-container" style={{padding:"40px",alignItems:'stretch'}}>
                <div className="logo">
                    <img src={MFLoginLogo} alt="mc-football-logo" />
                </div>
                 {passwordChnage ? (
                        <div className='signup-success-conatiner'>
                            <LabelText className='player-family-name' style={{color:'#54E0C5'}}>Password Changed Successfully!</LabelText>
                            <LabelText>Please <a style={{textDecoration:'underline',color:'black'}} onClick={()=>{navigate('/login')}}>Log in</a> to access your account.</LabelText>
                            <PrimaryButton className="login-button" label="Log in" onClick={()=>{navigate('/login')}}/>
                        </div>

                ):(
                <form className="login-form" autoComplete="off">
                        {/* <LabelText className='page-title-text'>Sign Up</LabelText> */}
                        <div className="form-group">
                            <LabelText className='custom-list-text'>Email</LabelText>
                            <div className="input-container">
                                <input
                                    type="text"
                                    name="username"
                                    placeholder='Enter your email address'
                                    autoComplete="off"
                                    value={email}
                                    onChange={handleEmailChange}
                                    disabled={sendOtp}
                                />
                                <span className="custom-icon">
                                    {email && (<CloseIcon onClick={!sendOtp ? handleClearUsername : undefined} style={{ cursor: sendOtp ? 'not-allowed' : 'pointer', opacity: sendOtp ? 0.4 : 1 }} />)}
                                </span> 
                            </div>
                            {!sendOtp &&(<LabelText><a  onClick={()=>{navigate('/login')}} style={{textDecoration:'underline',color:'#54E0C5',float:'inline-end'}}>Back to login</a></LabelText>)}   
                            {cooldown > 0 ? 
                            (<LabelText>Resend OTP in {formatTime(cooldown)}</LabelText>
                            ) : (
                                    sendOtp &&
                                    <LabelText ><a onClick={() => setIsResendOtp(true)} style={{cursor: 'pointer',textDecoration: 'underline',color: '#54E0C5'}}>Resend OTP</a></LabelText>
                                )}
                            {emailError && <LabelText className='error-text'>{emailError}</LabelText>}
                        </div>                        
                        {sendOtp && (
                            <>
                            <div className="form-group">
                            <LabelText className='custom-list-text'>OTP</LabelText>
                            <div className="input-container">
                                <input
                                    type={"number"}
                                    name="password"
                                    placeholder='Enter OTP'
                                    autoComplete="off"
                                    value={otp}
                                    maxLength={6}
                                    onChange={(event)=>{setOtp(parseInt(event.target.value))}}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <LabelText className='custom-list-text'>New Password</LabelText>
                            <div className="input-container">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder='Enter new password'
                                    autoComplete="off"
                                    value={password}
                                    onChange={handlePasswordChange}
                                />
                                {password &&(
                                    <span className="custom-icon" onClick={toggleShowPassword}>
                                        {showPassword ? <VisibilityIcon/> : <VisibilityOffIcon />}
                                    </span>
                                )}
                            </div>
                        {passwordErrors && <LabelText className='error-text'>{passwordErrors}</LabelText>}
                        </div>
                        <div className="form-group">
                            <LabelText className='custom-list-text'>Confirm Password</LabelText>
                            <div className="input-container">
                                <input
                                    type={showConfirmPasseord ? "text" : "password"}
                                    name="password"
                                    placeholder='Enter confirm password'
                                    autoComplete="off"
                                    value={confirmPassword}
                                    onChange={handleConfirmPassowrd}
                                />
                                {confirmPassword &&(
                                    <span className="custom-icon" onClick={()=>{setShowConfirmPassword(!showConfirmPasseord)}}>
                                        {showConfirmPasseord ? <VisibilityIcon/> : <VisibilityOffIcon />}
                                    </span>
                                )}
                            </div>
                            {passwordMatch && (<LabelText className='error-text'>{passwordMatch}</LabelText>)}
                        </div>
                            
                            </>
                        )}
                        
                    </form>
                                )}
                     {errorMsg &&(
                        <div className='error-container'>
                            <LabelText className='error-text'>{errorMsg ? errorMsg : ''}</LabelText>
                        </div>
                    )}
                    
                    {sendOtp  && !passwordChnage &&(
                        <div className="form-actions">
                            <PrimaryButton className="login-button" label="Submit" onClick={handleSubmit}
                            disabled={!otp || password === '' || confirmPassword === ''}/>
                        </div>
                    )}
                    {!sendOtp && !passwordChnage &&(
                         <div className="form-actions">
                            <PrimaryButton className="login-button" label="Send OTP" onClick={()=>{sendOtpFunction()}}
                            disabled={email === ''}/>
                        </div>
                    )}
                    
            </div>
            {loading && (<LoadingSpinner/>)}
        </div>
  )
}

export default ForgotPwd